module.exports = __webpack_public_path__ + "img/report-sample-16@3x.0bb4e0d0.png";